import { AbilityBuilder, createMongoAbility } from '@casl/ability';

import { permissionSystem } from '@adflow/shared/util-permissions';
import type { ViewAuthUserDto } from '@adflow/shared/util-users';

export function defineFallbackAbility() {
	const builder = new AbilityBuilder<permissionSystem.Ability>(
		createMongoAbility
	);

	return builder.build();
}

export function defineAbilityFor(user: ViewAuthUserDto | null | undefined) {
	if (!user) {
		return defineFallbackAbility();
	}

	const builder = new AbilityBuilder<permissionSystem.Ability>(
		createMongoAbility
	);

	// do high level permissions
	for (const permissionType of permissionSystem.permissionTypes) {
		for (const actionType of permissionSystem.actionTypes) {
			if (user.permissions?.[permissionType]?.[actionType]) {
				// can('create', 'User')
				builder.can(actionType, permissionType);
			}
		}
	}

	builder.cannot('update', 'User', 'superuser', { id: user.id });

	return builder.build();
}
